import React, { useState } from 'react';
import { Typography, Box, Card } from '@material-ui/core';
import moment from 'moment';
import { dateMonthYearDateFormat } from '../config/whatsNewConfig';

const cx = (...classNames) => classNames.filter(Boolean).join(' ');
const VISIBLE_COUNT = 4;
const EXPANDED_VISIBLE_COUNT = 8;

const RecentReleasesCard = ({ updates }) => {
    const [isExpanded, setExpanded] = useState(false);

    if (updates.length === 0) return null;

    const visibleUpdates = isExpanded ? updates : updates.slice(0, VISIBLE_COUNT);
    const canExpand = updates.length > VISIBLE_COUNT;
    const hasExpandedOverflow = updates.length > EXPANDED_VISIBLE_COUNT;

    const renderItem = (release, index, hasLineAfter) => (
        <Box key={release?.slug || release?.id || `${release?.title}-${release?.release_date}-${index}`} className="whats-new-recent-item">
            <Box className="whats-new-recent-timeline">
                <Box className="whats-new-recent-dot" />
                {hasLineAfter && <Box className="whats-new-recent-line" />}
            </Box>
            <Box className="whats-new-recent-content">
                <Typography className="whats-new-recent-date">{moment(release.release_date).format(dateMonthYearDateFormat)}</Typography>
                <Typography className="whats-new-recent-name">{release.title}</Typography>
            </Box>
        </Box>
    );

    return (
        <Card elevation={0} className="whats-new-recent-card">
            <Box className="whats-new-recent-header">
                <Typography className="whats-new-recent-title">Recent releases</Typography>
                {canExpand ? (
                    <Box component="button" type="button" onClick={() => setExpanded(prev => !prev)} className={cx('whats-new-recent-view-all', isExpanded && 'is-expanded')}> {isExpanded ? 'Show less' : 'Show more'} </Box>
                ) : null}
            </Box>
            <Box className={cx('whats-new-recent-list', isExpanded && 'is-expanded', isExpanded && hasExpandedOverflow && 'has-overflow')}>
                {visibleUpdates.map((release, index) => renderItem(release, index, index < visibleUpdates.length - 1))}
            </Box>
        </Card>
    );
};

export default RecentReleasesCard;